import { Text } from '@shopify/polaris'

// Release tag, baked in at build time by the Dockerfile (VITE_APP_VERSION).
// "dev" locally / when an untagged build runs without the env var.
const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string) || 'dev'

export default function AppVersionBadge() {
    // pointer-events: none so the badge never blocks UI underneath.
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 8,
                right: 12,
                opacity: 0.5,
                pointerEvents: 'none',
                zIndex: 1,
            }}
        >
            <Text as="span" tone="subdued" variant="bodyXs">
                {APP_VERSION}
            </Text>
        </div>
    )
}
